<template>
	<div
		:class="mapSize ? mapSize : 'map-sm'"
		ref="map"
		style="width:100%;"
	></div>
</template>

<script>
import GoogleMapsLoader from "@/mixins/GoogleMapsLoader"

export default {
	name: "VueMap",
	mixins: [GoogleMapsLoader],
	props: {
		center: Object,
		zoom: Number,
		mapSize: String,
		markers: {
			type: Array,
			default: () => []
		},
		circles: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			map: null,
			mapsRef: null,       // store google.maps here
			infoWindow: null,
			markerObjects: [],
			circleObjects: []
		};
	},

	async mounted() {
		// Load Maps via mixin
		const maps = await this.loadGoogleMaps(
			this.$store.GoogleEmbedAPIkey
		);

		this.mapsRef = maps;

		this.map = new maps.Map(this.$refs.map, {
			center: this.center,
			zoom: this.zoom
		});

		this.infoWindow = new maps.InfoWindow();

		this.renderMarkers();
		this.renderCircles();
	},

	methods: {

		renderMarkers() {
			if (!this.mapsRef) return;

			// Clear old markers
			this.markerObjects.forEach(m => m.setMap(null));
			this.markerObjects = [];

			this.markers.forEach(marker => {
				const m = new this.mapsRef.Marker({
					map: this.map,
					position: { lat: marker.lat, lng: marker.lng },
					draggable: marker.draggable ? marker.draggable : false,
					icon: marker.icon || null
				});

				m.addListener("click", () => {
					if (this.infoWindow && marker && marker.infoWindowText) {
						this.infoWindow.setContent(marker.infoWindowText);
						this.infoWindow.open(this.map, m);
					}
					this.$emit("markerClick", marker);
				});

				m.addListener("dragend", e => {
					this.$emit("markerDrop", {
						lat: e.latLng.lat(),
						lng: e.latLng.lng()
					}, marker);
				});

				this.markerObjects.push(m);
			});
		},

		renderCircles() {
			if (!this.mapsRef) return;

			// Clear old circles
			this.circleObjects.forEach(c => c.setMap(null));
			this.circleObjects = [];

			this.circles.forEach(circle => {
				const c = new this.mapsRef.Circle({
					map: this.map,
					center: { lat: circle.lat, lng: circle.lng },
					radius: circle.radius,
					strokeColor: circle.strokeColor,
					fillColor: circle.fillColor
				});

				this.circleObjects.push(c);
			});
		}
	},

	watch: {
		markers() {
			if (this.map && this.mapsRef) this.renderMarkers();
		},
		circles() {
			if (this.map && this.mapsRef) this.renderCircles();
		}
	}
};
</script>

<style scoped>
	.map-sm { height: 300px; max-height: calc(100vh - 120px); }
	.map-md { height: 500px; max-height: calc(100vh - 120px); }
	.map-lg { height: 700px; max-height: calc(100vh - 120px); }
	.map-inherit { height: 100%; }
</style>
